import moment from 'moment';
import React from 'react';
import { TransactionData } from '.';
import { DATE_TIME_FORMATS } from '../../../../data/constants';
const SideBar = (props: any) => {
  const { data, toggleViewSettlement, initialSettlementId } = props;
  const sidePanelDataKeys = [
    { key: 'openInfo', name: 'Device No', visible: true },
    { key: 'deviceLabels', name: 'Device Label', visible: true },
    {
      key: 'startTime',
      name: 'Shift Start Time',
      formatTime: true,
      visible: true,
    },
    { key: 'endTime', name: 'Shift End Time', formatTime: true, visible: true },
    {
      key: 'previousSettlementInfo',
      name: 'Previous cashier',
      hideMobile: true,
      visible: initialSettlementId === data.mid,
    },
    {
      key: 'nextSettlementInfo',
      name: 'Next Cashier',
      hideMobile: true,
      visible: initialSettlementId === data.mid,
    },
  ];

  function getContainerCss() {
    return 'pt-24 sm:pt-15 sm:pb-0 sm:mb-16 w-[198px] sm:w-full sm:ml-0 flex flex-col bg-[#397EF5]/5 rounded-[8px] ml-30 h-auto';
  }

  return (
    <div className={getContainerCss()}>
      {sidePanelDataKeys.map(
        ({ name, key, formatTime = false, hideMobile = false, visible }) => {
          let fieldName = key as keyof TransactionData;
          return (
            visible && (
              <div
                className={`mb-[25px] px-32 sm:px-16 ${
                  fieldName === 'endTime'
                    ? 'border-b-[1px] sm:border-b-[0px] border-black/[14%] pb-[30px] sm:pb-[13px]  sm:mb-[0px] '
                    : ' sm:mb-[13px] '
                } ${hideMobile ? 'sm:hidden' : ''} `}
              >
                {fieldName === 'nextSettlementInfo' ||
                fieldName === 'previousSettlementInfo' ? (
                  data[fieldName] && (
                    <div>
                      <div className="text-13 text-black/[48%]">{name}</div>
                      <div className="font-medium text-17 text-black">
                        {data[fieldName]?.userInfo?.userName?.firstName}
                      </div>
                      <div
                        onClick={() =>
                          toggleViewSettlement(data[fieldName].settlementId)
                        }
                        className="cursor-pointer text-12 text-[#397EF5] mt-5 flex "
                      >
                        <div>View Transaction </div>
                        <div className="rista-sprite ic-arrow-left-blue rotate-180"></div>
                      </div>
                    </div>
                  )
                ) : fieldName === 'openInfo' ? (
                  <div className="sm:flex items-center justify-between">
                    <div className="text-13 sm:text-[12px] text-black/[48%]">
                      {name}
                    </div>
                    <div className="mt-5 sm:mt-0 text-14 font-medium text-black">
                      {data[fieldName]?.deviceInfo?.serialNumber}
                    </div>
                  </div>
                ) : (
                  <div className="sm:flex items-center justify-between">
                    <div className="text-13 sm:text-[12px] text-black/[48%]">
                      {name}
                    </div>
                    <div className="mt-5 sm:mt-0 text-14 whitespace-nowrap text-ellipsis overflow-hidden font-medium text-black flex flex-col sm:flex-row">
                      {formatTime ? (
                        data[fieldName] ? (
                          <>
                            <div>
                              {moment(data[fieldName]).format(
                                DATE_TIME_FORMATS.time
                              )}
                            </div>
                            <div className="sm:ml-3">
                              {moment(data[fieldName]).format(
                                DATE_TIME_FORMATS.dayMonthYear
                              )}
                            </div>
                          </>
                        ) : (
                          ''
                        )
                      ) : (
                        data[fieldName]?.name || data[fieldName] || ''
                      )}
                    </div>
                  </div>
                )}
              </div>
            )
          );
        }
      )}
      {initialSettlementId !== data.mid && (
        <div
          onClick={() => toggleViewSettlement(initialSettlementId)}
          className="sm:hidden cursor-pointer pl-32 pr-54 text-12 text-[#397EF5] mt-5 flex "
        >
          <div className="rista-sprite mr-8 ic-arrow-left-blue"></div>
          <div>Back to Current Cashier </div>
        </div>
      )}
    </div>
  );
};
export default SideBar;
